<template>
  <div class="payment-info expired-payment">
    <div class="payment-header expired">支払情報（受給権消滅）</div>
    <div class="payment-content">
      <div class="payment-row d-flex justify-content-between">
        <div class="payment-label">受給権消滅日</div>
        <div class="payment-value">{{ expirationDate }}</div>
      </div>
      <div class="payment-row d-flex justify-content-between">
        <div class="payment-label">金額</div>
        <div class="payment-value amount">{{ amount }}円</div>
      </div>
      <!-- <div class="expired-note">
        <div class="expired-note">
          <p>
            「マナビス・スキンケア・クラブ紹介活動により生じたコミッション」のお支払手続きの完了していないコミッションについて、マナビス・スキンケア・クラブ会員マニュアルでは、支払期日から６ヶ月経過した場合、受給権が消滅いたします。
          </p>
          <p>
            既にお知らせいたしました当該コミッションは振込口座の指定または再指定が無く６ヶ月が経過したため、下記期日をもって受給権が消滅いたしました。ご不明な点につきましては、お手数ですがフリーダイヤル（0120-268-510）までお問合せくださいますようお願いいたします。
          </p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpiredPaymentInfo",
  props: {
    expirationDate: {
      type: String,
      default: "2024年9月20日",
    },
    amount: {
      type: String,
      default: "0",
    },
  },
};
</script>

<style scoped>
.payment-info {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.payment-header {
  padding: 10px 15px;
  font-weight: 600;
  border-radius: 4px 4px 0 0;
}

.payment-header.expired {
  background-color: #333;
  color: #fff;
}

.payment-content {
  padding: 15px;
}

.payment-row {
  padding: 8px 0;
  border-bottom: 1px dotted #ddd;
}

.payment-row:last-child {
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.payment-value.amount {
  font-weight: 600;
}

.expired-note {
  margin-top: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 0.9rem;
}

.expired-note p {
  margin: 5px 0;
}
</style> 